
import { Component, Vue } from "vue-property-decorator";
import { Settings } from "../../../core/services/configService";
import { CrudService } from "../../../core/services/crudService";
import store from "../../../core/store";
import { DateHelper } from "../../../core/helpers/dateHelper";
import { Camp } from "./campPage.vue";
import ScrollableBanner from "../scrollableBanner.vue";
import CampCard from "./campCard.vue";

@Component({
  components: {
    ScrollableBanner,
    CampCard,
  },
})
export default class CampsBanner extends Vue {
  private camps: Camp[] = [];

  async mounted() {
    this.loadCamps();
  }

  private async loadCamps() {
    const url = `${Settings.HostName}/api/publiccamps/list`;
    const data = await new CrudService().httpGet(url);
    if (data == null || !data.ok) {
      console.error("Crash");
      return;
    }
    const camps = data.model as Camp[];
    camps.forEach((camp) => {
      if (camp.start) {
        const startDate = DateHelper.toDate(
          camp.start,
          DateHelper.systemFormat
        )!;
        camp.startStr = DateHelper.beautifyDate(
          DateHelper.toServerFormat(startDate),
          true,
          true,
          true,
          false
        );
      }
      if (camp.inscriptionStart) {
        const inscriptionStartDate = DateHelper.toDate(
          camp.inscriptionStart,
          DateHelper.systemFormat
        )!;
        camp.inscriptionStartStr = DateHelper.formatDate(
          inscriptionStartDate,
          store.state.settings.DateNoTimeFormat
        );
      }
      if (camp.inscriptionEnd) {
        const inscriptionEndDate = DateHelper.toDate(
          camp.inscriptionEnd,
          DateHelper.systemFormat
        )!;
        camp.inscriptionEndStr = DateHelper.formatDate(
          inscriptionEndDate,
          store.state.settings.DateNoTimeFormat
        );
      }
    });
    this.camps = camps;
  }
}
